import { Effect } from 'effect';

import type { OrderShipmentStorageT } from '../../service/orderShipment/OrderShipment';
import { OrderShipment } from '../../service/orderShipment/OrderShipment';

export const getOrderShipment = Effect.gen(function* () {
  const orderShipmentService = yield* OrderShipment;

  return yield* orderShipmentService.getOrderShipment.pipe(
    Effect.catchTags({
      '@app/OrderShipment/OrderShipmentGetError': () => Effect.succeed(null),
    })
  );
});

export const setOrderShipment = (orderShipment: OrderShipmentStorageT) =>
  Effect.gen(function* () {
    const orderShipmentService = yield* OrderShipment;

    return yield* orderShipmentService.setOrderShipment(orderShipment);
  });

export const removeOrderShipment = Effect.gen(function* () {
  const orderShipmentService = yield* OrderShipment;

  return yield* orderShipmentService.removeOrderShipment;
});
